/**
 * Home-page Trade Category / Public-Facing icons.
 * Filenames are stored on the Trade Category records; this map resolves them
 * to the bundled SVGs used on the home page.
 */
import Plumbing from '../assets/img/services/latest/plumbing.svg';
import Electrical from '../assets/img/services/latest/electrical.svg';
import Carpentry from '../assets/img/services/latest/carpentry.svg';
import CabinetMaking from '../assets/img/services/latest/cabinet-making.svg';
import Renovation from '../assets/img/services/latest/renovation.svg';
import Roofing from '../assets/img/services/latest/roofing.svg';
import PaintingAndDecorating from '../assets/img/services/latest/painting-and-decorating.svg';
import Tiling from '../assets/img/services/latest/tiling.svg';
import Flooring from '../assets/img/services/latest/flooring.svg';
import CarpetAndFlooring from '../assets/img/services/latest/carpetandflooring.svg';
import Plastering from '../assets/img/services/latest/plastering.svg';
import Bricklaying from '../assets/img/services/latest/bricklaying.svg';
import Concreting from '../assets/img/services/latest/concreting.svg';
import Waterproofing from '../assets/img/services/latest/waterproofing.svg';
import Demolition from '../assets/img/services/latest/demolition.svg';
import Scaffolding from '../assets/img/services/latest/scafolding.svg';
import SkipBins from '../assets/img/services/latest/skipbins.svg';
import Excavation from '../assets/img/services/latest/excavation.svg';
import Landscaping from '../assets/img/services/latest/landscaping.svg';
import TreeServices from '../assets/img/services/latest/tree-services.svg';
import FencingAndGates from '../assets/img/services/latest/fencing-and-gates.svg';
import AirConditioning from '../assets/img/services/latest/air-conditioning.svg';
import HeatingSystems from '../assets/img/services/latest/heating-systems.svg';
import Refrigeration from '../assets/img/services/latest/refrigeration.svg';
import SolarPower from '../assets/img/services/latest/solar-power.svg';
import GlassAndGlazing from '../assets/img/services/latest/glass-and-glazing.svg';
import PoolsAndSpas from '../assets/img/services/latest/pools-and-spas.svg';
import PestControl from '../assets/img/services/latest/pest-control.svg';
import CleaningServices from '../assets/img/services/latest/cleaning-services.svg';
import BlindsAndCurtains from '../assets/img/services/latest/blinds-and-curtains.svg';
import Drafting from '../assets/img/services/latest/drafting.svg';
import InteriorDesign from '../assets/img/services/latest/interior-design.svg';
import Surveying from '../assets/img/services/latest/surveying.svg';
import EngineeringServices from '../assets/img/services/latest/engineering-services.svg';
import PlansAndPermits from '../assets/img/services/latest/plans-and-permits.svg';
import BuildingInspection from '../assets/img/services/latest/building-inspection.svg';
import InsulationServices from '../assets/img/services/latest/insulation-services.svg';
import HandymanServices from '../assets/img/services/latest/handyman-services.svg';
import Locksmith from '../assets/img/services/latest/locksmith.svg';
import Shopfitting from '../assets/img/services/latest/shopfitting.svg';
import StoneBenchtops from '../assets/img/services/latest/stone-benchtops.svg';
import ShowerScreens from '../assets/img/services/latest/shower-screens.svg';
import Staircase from '../assets/img/services/latest/stair-case.svg';
import GasFitting from '../assets/img/services/latest/gas-fitting.svg';
import HomeAutomation from '../assets/img/services/latest/home-automation.svg';
import Decking from '../assets/img/services/latest/decking.svg';
import Pergolas from '../assets/img/services/latest/pergolas.svg';
import Rendering from '../assets/img/services/latest/rendering.svg';
import Caulking from '../assets/img/services/latest/chalking.svg';
export { slugifyName as slugifyTradeCategoryName } from '../utils/slugify';

export const TRADE_CATEGORY_ICON_BY_FILE = {
  'plumbing.svg': Plumbing,
  'electrical.svg': Electrical,
  'carpentry.svg': Carpentry,
  'cabinet-making.svg': CabinetMaking,
  'renovation.svg': Renovation,
  'roofing.svg': Roofing,
  'painting-and-decorating.svg': PaintingAndDecorating,
  'tiling.svg': Tiling,
  'flooring.svg': Flooring,
  'carpetandflooring.svg': CarpetAndFlooring,
  'plastering.svg': Plastering,
  'bricklaying.svg': Bricklaying,
  'concreting.svg': Concreting,
  'waterproofing.svg': Waterproofing,
  'demolition.svg': Demolition,
  'scafolding.svg': Scaffolding,
  'skipbins.svg': SkipBins,
  'excavation.svg': Excavation,
  'landscaping.svg': Landscaping,
  'tree-services.svg': TreeServices,
  'fencing-and-gates.svg': FencingAndGates,
  'air-conditioning.svg': AirConditioning,
  'heating-systems.svg': HeatingSystems,
  'refrigeration.svg': Refrigeration,
  'solar-power.svg': SolarPower,
  'glass-and-glazing.svg': GlassAndGlazing,
  'pools-and-spas.svg': PoolsAndSpas,
  'pest-control.svg': PestControl,
  'cleaning-services.svg': CleaningServices,
  'blinds-and-curtains.svg': BlindsAndCurtains,
  'drafting.svg': Drafting,
  'interior-design.svg': InteriorDesign,
  'surveying.svg': Surveying,
  'engineering-services.svg': EngineeringServices,
  'plans-and-permits.svg': PlansAndPermits,
  'building-inspection.svg': BuildingInspection,
  'insulation-services.svg': InsulationServices,
  'handyman-services.svg': HandymanServices,
  'locksmith.svg': Locksmith,
  'shopfitting.svg': Shopfitting,
  'stone-benchtops.svg': StoneBenchtops,
  'shower-screens.svg': ShowerScreens,
  'stair-case.svg': Staircase,
  'gas-fitting.svg': GasFitting,
  'home-automation.svg': HomeAutomation,
  'decking.svg': Decking,
  'pergolas.svg': Pergolas,
  'rendering.svg': Rendering,
  'chalking.svg': Caulking,
};

export function resolveTradeCategoryIconSrc(iconUrl = '', iconFileName = '') {
  if (iconUrl) return iconUrl;
  if (!iconFileName) return '';
  return TRADE_CATEGORY_ICON_BY_FILE[iconFileName] || '';
}
